export default {"src":"/_next/static/media/Phone.55511dd0.svg","height":47,"width":47};